module.exports = __webpack_public_path__ + "static/header-29d326c84356714cb164e664927dd613.svg";